var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2059 19.1976C13.1172 20.253 11.9284 20.0864 10.7841 19.5864C9.57318 19.0754 8.46221 19.0531 7.18459 19.5864C5.5848 20.2752 4.74046 20.0752 3.78502 19.1976C-1.63652 13.6094 -0.836616 5.09936 5.31816 4.78828C6.81797 4.86605 7.86229 5.6104 8.73995 5.67706C10.0509 5.41043 11.3063 4.64386 12.7061 4.74385C14.3837 4.87716 15.6502 5.54374 16.4834 6.74359C13.0172 8.82111 13.8393 13.3872 17.0167 14.6648C16.3834 16.3313 15.5613 17.9866 14.1948 19.2087L14.2059 19.1976ZM8.62886 4.72163C8.46221 2.24416 10.4731 0.199975 12.7839 0C13.1061 2.8663 10.1842 4.99937 8.62886 4.72163Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppelIcon);
export default __webpack_public_path__ + "static/media/appel-Icon.a00f171450f0dae97620f840dbec272c.svg";
export { ForwardRef as ReactComponent };